var _circle, _circle2, _path, _circle3, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#089ED1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 60C43.0457 60 51.5 56.0457 51.5 45C51.5 35.2033 44.8496 35.3114 35.6392 35.4611C34.4649 35.4802 33.249 35.5 32 35.5C30.7615 35.5 29.543 35.4806 28.3556 35.4616C18.953 35.3117 11.5 35.1928 11.5 45C11.5 56.0457 20.9543 60 32 60Z",
    fill: "#373737",
    fillOpacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 29,
    r: 14,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24C44 30.6274 38.6274 38.5 32 38.5C25.3726 38.5 20 30.6274 20 24C20 17.3726 25.3726 12 32 12C38.6274 12 44 17.3726 44 24Z",
    fill: "#373737"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24C44 30.6274 38.6274 38.5 32 38.5C25.3726 38.5 20 30.6274 20 24C20 17.3726 25.3726 12 32 12C38.6274 12 44 17.3726 44 24Z",
    fill: "#AAA6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.6333c8b8b7bc7bc4bb21f66dadf582b3.svg";
export { ForwardRef as ReactComponent };